"use client";
import { Category } from "@/api/home";
import SwiperGroup from "@/components/Card/SwiperGroup";
import Manufacturer from "@/components/Manufacturer";
import { useRouter } from "@/i18n/routing";
import React from "react";
import HomeSearch from "./HomeSearch";

interface Props {
    groupGames: Category[];
    // group: GroupType[];
}

// const Manufacturer = (props: { data: GameListRep[]; group: Category }) => {
//     const router = useRouter();
//     const { data, group } = props;
//     const todoHandler = (item: GameListRep) => {
//         router.push({
//             pathname: `/gameList/?gameListFlag=${item.id}&type=2&bet_type=${group.bet_type}&name=${item.provider}`,
//         });
//     };
//     const elements = data.map((item, index) => {
//         return (
//             <img
//                 key={index}
//                 className={"rounded-[0.05rem]"}
//                 onClick={() => todoHandler(item)}
//                 src={item.game_icon}
//                 alt=""
//             />
//         );
//     });

//     return <div className={"grid grid-cols-4 gap-x-[14px] gap-y-[14px]"}>{elements}</div>;
// };

const HomeGames = (props: Props) => {
    const router = useRouter();

    const { groupGames = [] } = props;
    const todoHandler = (item: Category) => {
        router.push(
            `/gameList/?gameListFlag=${item.jump_id}&type=${item.type}&bet_type=${item.bet_type}&name=${item.category_name}`
        );
    };

    const providers = React.useMemo(() => {
        const providersData = groupGames.filter((item) => item.type === 2);
        return providersData[0];
    }, [groupGames]);
    return (
        <>
            {providers && (
                <React.Fragment>
                    <Manufacturer data={providers}></Manufacturer>
                </React.Fragment>
            )}
            <div className="mb-[.2rem] px-[.12rem]">
                <HomeSearch></HomeSearch>
            </div>

            {groupGames.map((group, index) => {
                if (group.type !== 2) {
                    return (
                        <SwiperGroup
                            key={index}
                            group={group}
                            col={3}
                            visibleTodos={true}
                            todoHandler={todoHandler}
                        ></SwiperGroup>
                    );
                }
            })}
        </>
    );
};

export default HomeGames;
